import type { InputHTMLAttributes, ReactNode, Ref } from 'react';

export interface PrimitiveInputProps extends InputHTMLAttributes<HTMLInputElement> {
  ref?: Ref<HTMLInputElement>;
}

export function PrimitiveInput(props: PrimitiveInputProps): ReactNode {
  return <input {...props} data-component="PrimitiveInput" />;
}
